import { PropsWithChildren } from 'react';

import { useIsMobileSize } from 'hooks';
import { TestAttributeProps } from 'types/testAttribute';

import { Tooltip } from '../Tooltip';

import { TypographyStyled } from './Typography.styles';
import { TypographyProps } from './types';

/**
 * Typography component.
 */

export const Typography = ({
  children,
  variant = 'body',
  variantMobile,
  className,
  title,
  align,
  color,
  as,
  maxLine,
  whiteSpace,
  datax,
  onClick,
}: TypographyProps & PropsWithChildren & TestAttributeProps) => {
  const isMobile = useIsMobileSize();
  return (
    <Tooltip placement="top-start" title={title}>
      <TypographyStyled
        align={align}
        as={as}
        className={className}
        color={color}
        datax={datax}
        maxLine={maxLine}
        variant={isMobile && variantMobile ? variantMobile : variant}
        whiteSpace={whiteSpace}
        onClick={onClick}
      >
        {children}
      </TypographyStyled>
    </Tooltip>
  );
};
